import Preview from "./alignment/linearPreview";
import AlignmentContainer from "./alignment/alignment";
import Overview from "./alignment/overview";
import Sidebar from "./alignment/sidebar";
import Mediator from "./editor/mediator";
import axios from "axios";


document.addEventListener("DOMContentLoaded", function () {
    const container = document.getElementById("alignment")
    if (container) {
        axios.get(container.dataset.url).then(result => {
            const mediator = new Mediator();
            const alignment = new AlignmentContainer({
                "annotation_colors": JSON.parse(document.getElementById("colors").innerHTML),
            }, mediator);

            new Preview({}, mediator);
            new Overview({}, mediator);
            new Sidebar({
                "annotation_colors": JSON.parse(document.getElementById("colors").innerHTML),
            }, mediator);

            alignment.setData(result.data);
        })

        if (container.dataset.valid === 'false') {
            let invalidAlignmentModal = new Modal('#invalidAlignmentModal');
            invalidAlignmentModal.show();
        }
    }
});
